"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagPaymentAsOutstanding = exports.flagPaymentAsWriteOff = exports.updateTransferContract = exports.updateSupplier = exports.deleteProduct = exports.updateProductRates = exports.updateProduct = exports.approveSupplier = exports.getSupplier = exports.addSupplier = exports.getAllRegionalTransferContracts = exports.getAllTransferContracts = exports.getSupplierVehicles = exports.getTransferContracts = exports.deleteRate = exports.addProduct = exports.addRates = exports.addTransferContract = exports.getContractComments = exports.addContractComment = exports.deleteContract = exports.getSuppliersByType = exports.getSuppliers = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const dayjs = require("dayjs");
const _ = require("lodash");
const getSuppliers = async (supabase) => {
    const { data, error } = await supabase
        .from("suppliers")
        .select(`*, 
      supplier_payment_outstanding(*),
      golf_contracts: golf_contracts(*),
      country:country_id ( id, name, slug )`)
        .order("created_at", { ascending: false });
    if (!error)
        return data.map((supplier) => ({
            ...supplier,
            country: !supplier.country
                ? null
                : {
                    id: supplier.country.id,
                    name: supplier.country.name,
                    slug: supplier.country.slug,
                },
        }));
    return error;
};
exports.getSuppliers = getSuppliers;
const getSuppliersByType = async (supabase, type) => {
    const { data, error } = await supabase
        .from("suppliers")
        .select(`*, 
      supplier_payment_outstanding(*),
      golf_contracts: golf_contracts(*),
      country:country_id ( id, name, slug )`)
        .order("created_at", { ascending: false })
        .eq(`offerings->${type}->enabled`, true)
        .neq("currency", null);
    if (!error)
        return data.map((supplier) => ({
            ...supplier,
            country: !supplier.country
                ? null
                : {
                    id: supplier.country.id,
                    name: supplier.country.name,
                    slug: supplier.country.slug,
                },
        }));
    return error;
};
exports.getSuppliersByType = getSuppliersByType;
const deleteContract = async (supabase, id) => {
    await supabase
        .from("transfer_contract_notes")
        .delete()
        .eq("transfer_contract_id", id);
    const { data, error } = await supabase
        .from("transfer_contracts")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContract = deleteContract;
const addContractComment = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id;
    obj.created_by = user?.id;
    const { data, error } = await supabase
        .from("transfer_contract_notes")
        .insert([obj])
        .single();
    if (!error)
        return data;
    return error;
};
exports.addContractComment = addContractComment;
const getContractComments = async (supabase, id) => {
    const { data, error } = await supabase
        .from("transfer_contract_notes")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("transfer_contract_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getContractComments = getContractComments;
const addTransferContract = async (supabase, obj) => {
    const { data, error } = await supabase.from("transfer_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addTransferContract = addTransferContract;
const addRates = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("transfer_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addRates = addRates;
const addProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.config;
    const { data, error } = await supabase
        .from("transfer_contract_products")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addProduct = addProduct;
const deleteRate = async (supabase, id) => {
    const { data, error } = await supabase
        .from("transfer_contract_product_rates")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteRate = deleteRate;
const getTransferContracts = async (supabase, supplier_id) => {
    const { data: vehicles } = await supabase.from("vehicles").select("*");
    const { data: platforms } = await supabase.from("platforms").select("*");
    const { data: areas } = await supabase
        .from("areas")
        .select("*, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )");
    const { data: contracts, error } = await supabase
        .from("transfer_contracts")
        .select(`*, 
      area:area_id (id, name, type, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )), 
      custom_area:custom_area_id (id, name, type, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )), 
      supplier:supplier_id (id, name, currency), 
      transfer_contract_notes(count),
      transfer_contract_products(
        *,        
        transfer_contract_product_rates(
          *,
          from:areas!from_area(id, name, type),
          to:areas!to_area(id, name, type),
          via:areas!via_area(id, name, type)
        )
      )`)
        .eq("supplier_id", supplier_id);
    if (!error)
        return {
            platforms: platforms,
            vehicles: vehicles,
            areas: areas?.map((area) => ({
                id: area.id,
                name: area.name,
                type: area.type,
                created_at: area.created_at,
                created_by: area.created_by,
                created_by_user: area.created_by_user,
                modified_by_user: area.modified_by_user,
                modified_at: area.modified_at,
                modified_by: area.modified_by,
                region: {
                    id: area?.region?.id,
                    name: area?.region?.name,
                    slug: area?.region?.slug,
                },
                country: {
                    id: area?.region?.country?.id,
                    name: area?.region?.country?.name,
                    slug: area?.region?.country?.slug,
                },
            })),
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    type: contract.type,
                    payment_terms: contract.payment_terms,
                    created_at: contract.created_at,
                    platforms: contract.platforms || [],
                    comments_count: contract.transfer_contract_notes[0].count,
                    custom_area_id: contract?.custom_area_id,
                    custom_area: {
                        id: contract?.custom_area?.id,
                        name: contract?.custom_area?.name,
                        type: contract?.custom_area?.type,
                        country_id: contract?.custom_area?.region?.country.id,
                    },
                    area_id: contract.area_id,
                    area: {
                        id: contract.area.id,
                        name: contract.area.name,
                        type: contract.area.type,
                        country_id: contract.area.region.country.id,
                    },
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.transfer_contract_products.map((product) => ({
                        id: product.id,
                        vehicle_id: product.vehicle_id,
                        config: product.config,
                        contract_id: contract.id,
                        created_at: product.created_at,
                        rates: product.transfer_contract_product_rates.map((rate) => ({
                            ...rate,
                            contract_id: contract.id,
                        })),
                    })),
                })),
        };
    return error;
};
exports.getTransferContracts = getTransferContracts;
const getSupplierVehicles = async (supabase, supplier_id) => {
    const { data: contracts, error } = await supabase
        .from("transfer_contracts")
        .select(`products:transfer_contract_products(
        vehicle:vehicle_id (*)
      )`)
        .eq("supplier_id", supplier_id);
    if (!error) {
        let vehicles = [];
        contracts.forEach((contract) => {
            contract.products.forEach((product) => {
                vehicles.push(product.vehicle);
            });
        });
        // remove duplicates
        vehicles = _.uniqBy(vehicles, "id");
        return vehicles;
    }
    return error;
};
exports.getSupplierVehicles = getSupplierVehicles;
const getAllTransferContracts = async (supabase) => {
    const { data: vehicles } = await supabase.from("vehicles").select("*");
    const { data: platforms } = await supabase.from("platforms").select("*");
    const { data: areas } = await supabase
        .from("areas")
        .select("*, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )");
    const { data: contracts, error } = await supabase
        .from("transfer_contracts")
        .select(`*, 
      area:area_id (id, name, type, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )), 
      supplier:supplier_id (id, name, currency), 
      transfer_contract_notes(count),
      transfer_contract_products(
        *,        
        transfer_contract_product_rates(
          *,
          from:from_area(id, name, type, region:region_id ( id)),
          to:to_area(id, name, type)
        )
      )`);
    if (!error)
        return {
            platforms: platforms,
            vehicles: vehicles,
            areas: areas?.map((area) => ({
                id: area.id,
                name: area.name,
                type: area.type,
                created_at: area.created_at,
                created_by: area.created_by,
                created_by_user: area.created_by_user,
                modified_by_user: area.modified_by_user,
                modified_at: area.modified_at,
                modified_by: area.modified_by,
                region: {
                    id: area?.region?.id,
                    name: area?.region?.name,
                    slug: area?.region?.slug,
                },
                country: {
                    id: area?.region?.country?.id,
                    name: area?.region?.country?.name,
                    slug: area?.region?.country?.slug,
                },
            })),
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    type: contract.type,
                    payment_terms: contract.payment_terms,
                    created_at: contract.created_at,
                    platforms: contract.platforms || [],
                    comments_count: contract.transfer_contract_notes[0].count,
                    area_id: contract.area_id,
                    area: {
                        id: contract.area.id,
                        name: contract.area.name,
                        type: contract.area.type,
                        country_id: contract.area.region.country.id,
                    },
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.transfer_contract_products.map((product) => ({
                        id: product.id,
                        vehicle_id: product.vehicle_id,
                        config: product.config,
                        contract_id: contract.id,
                        created_at: product.created_at,
                        rates: product.transfer_contract_product_rates.map((rate) => ({
                            ...rate,
                            contract_id: contract.id,
                        })),
                    })),
                })),
        };
    return error;
};
exports.getAllTransferContracts = getAllTransferContracts;
const getAllRegionalTransferContracts = async (supabase, region_id) => {
    const { data: vehicles } = await supabase.from("vehicles").select("*");
    const { data: platforms } = await supabase.from("platforms").select("*");
    const { data: areas } = await supabase
        .from("areas")
        .select("*, region:region_id!inner ( id, name, slug, country:country_id ( id, name, slug ) )")
        .eq("region_id", region_id);
    const { data: contracts, error } = await supabase
        .from("transfer_contracts")
        .select(`*, 
      area:area_id (id, name, type, region:regions!region_id ( id, name, slug, country:country_id ( id, name, slug ) )), 
      custom_area:custom_area_id (id, name, type, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )), 
      supplier:supplier_id (id, name, currency), 
      transfer_contract_notes(count),
      transfer_contract_products(
        *,        
        transfer_contract_product_rates(
          *,
          from:from_area(id, name, type, region_id),
          to:to_area(id, name, type, region_id),
          via:via_area(id, name, type, region_id)
        )
      )`);
    const now = dayjs().unix();
    if (!error) {
        const obj = {
            platforms: platforms,
            vehicles: vehicles,
            areas: areas?.map((area) => ({
                id: area.id,
                name: area.name,
                type: area.type,
                created_at: area.created_at,
                created_by: area.created_by,
                created_by_user: area.created_by_user,
                modified_by_user: area.modified_by_user,
                modified_at: area.modified_at,
                modified_by: area.modified_by,
                region: {
                    id: area?.region?.id,
                    name: area?.region?.name,
                    slug: area?.region?.slug,
                },
                country: {
                    id: area?.region?.country?.id,
                    name: area?.region?.country?.name,
                    slug: area?.region?.country?.slug,
                },
            })),
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    type: contract.type,
                    payment_terms: contract.payment_terms,
                    created_at: contract.created_at,
                    platforms: contract.platforms || [],
                    comments_count: contract.transfer_contract_notes[0].count,
                    area_id: contract.area_id,
                    area: {
                        id: contract.area.id,
                        name: contract.area.name,
                        type: contract.area.type,
                        country_id: contract.area.region.country.id,
                    },
                    custom_area_id: contract?.custom_area_id,
                    custom_area: {
                        id: contract?.custom_area?.id,
                        name: contract?.custom_area?.name,
                        type: contract?.custom_area?.type,
                        country_id: contract?.custom_area?.region?.country.id,
                    },
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.transfer_contract_products.map((product) => ({
                        id: product.id,
                        vehicle_id: product.vehicle_id,
                        config: product.config,
                        contract_id: contract.id,
                        created_at: product.created_at,
                        rates: product.transfer_contract_product_rates.map((rate) => ({
                            ...rate,
                            contract_id: contract.id,
                        })),
                    })),
                })),
        };
        // filter the contracts where there are products with rates where the rate from area is in the region
        obj.contracts = obj.contracts.filter((contract) => {
            const products = contract.products.filter((product) => {
                const rates = product.rates.filter((rate) => {
                    return (rate?.from?.region_id === region_id ||
                        rate?.to?.region_id === region_id);
                });
                return rates.length > 0;
            });
            return products.length > 0;
        });
        // filter out all areas that are not in the region
        if (obj.areas) {
            obj.areas = obj.areas.filter((area) => {
                return area.region.id === region_id;
            });
        }
        obj.contracts = obj.contracts.filter((contract) => {
            const start = dayjs(contract.start_date).unix();
            const end = dayjs(contract.end_date).unix();
            return start <= now && end >= now;
        });
        return obj;
    }
    return error;
};
exports.getAllRegionalTransferContracts = getAllRegionalTransferContracts;
const addSupplier = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("suppliers")
        .insert([obj])
        .select();
    if (!error)
        return data;
    return error;
};
exports.addSupplier = addSupplier;
const getSupplier = async (supabase, id) => {
    const { data, error } = await supabase
        .from("suppliers")
        .select(`*,
      golf_contracts: golf_contracts(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getSupplier = getSupplier;
const approveSupplier = async (supabase, id, status) => {
    const { data, error } = await supabase
        .from("suppliers")
        .update({ approved: status })
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.approveSupplier = approveSupplier;
const updateProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    const { data, error } = await supabase
        .from("transfer_contract_products")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProduct = updateProduct;
const updateProductRates = async (supabase, rates) => {
    const obj = _.cloneDeep(rates);
    // in each rate delete the contract_id property
    obj.forEach((rate) => {
        delete rate.contract_id;
        delete rate.from;
        delete rate.to;
        delete rate.via;
    });
    const { data, error } = await supabase
        .from("transfer_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProductRates = updateProductRates;
const deleteProduct = async (supabase, id) => {
    await supabase
        .from("transfer_contract_product_rates")
        .delete()
        .eq("contract_product_id", id);
    const { data, error } = await supabase
        .from("transfer_contract_products")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteProduct = deleteProduct;
const updateSupplier = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    delete updateObj.golf_contracts;
    const { data, error } = await supabase
        .from("suppliers")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateSupplier = updateSupplier;
const updateTransferContract = async (supabase, contracts) => {
    const obj = _.cloneDeep(contracts);
    obj.forEach((contract) => {
        delete contract.products;
    });
    const { data, error } = await supabase.from("transfer_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateTransferContract = updateTransferContract;
const flagPaymentAsWriteOff = async (supabase, id) => {
    const { data, error } = await supabase
        .from("supplier_payment_outstanding")
        .update({ write_off: true })
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.flagPaymentAsWriteOff = flagPaymentAsWriteOff;
const flagPaymentAsOutstanding = async (supabase, id) => {
    const { data, error } = await supabase
        .from("supplier_payment_outstanding")
        .update({ write_off: false })
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.flagPaymentAsOutstanding = flagPaymentAsOutstanding;
